/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ChoiceList.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-choiceList");
exports.ChoiceList = function ChoiceList(_a) {
    var title = _a.title, children = _a.children, compact = _a.compact, bordered = _a.bordered, className = _a.className, noHover = _a.noHover;
    return (React.createElement("ul", { className: classnames(moduleClassName(), className, compact && moduleClassName("compact"), bordered && moduleClassName("bordered"), noHover && moduleClassName("noHover")) },
        !!title && (React.createElement("li", { key: "choiceList-header", className: moduleClassName("header") }, title)),
        children));
};
exports.ChoiceList.propTypes = {
    title: PropTypes.string,
    compact: PropTypes.bool,
    noHover: PropTypes.bool,
    bordered: PropTypes.bool
};
exports.ChoiceListLink = function ChoiceListLink(_a) {
    var children = _a.children, selected = _a.selected, onClick = _a.onClick;
    return (React.createElement("li", { className: classnames(moduleClassName("linkItem"), selected && moduleClassName("linkItem-isSelected")) },
        React.createElement("a", { className: moduleClassName("link"), role: "button", onClick: onClick }, children)));
};
exports.ChoiceListLink.propTypes = {
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool
};